import makeStyles from '@mui/styles/makeStyles';
import { isDark } from 'global/styles';

export const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  rowTop: {
    display: 'flex',
    alignItems: 'baseline',
  },
  cpScoreHeaderChild: {
    width: 48,
    minWidth: 48,
    textAlign: 'center',
    margin: 0,
  },
  refLabel: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textFillColor: theme.palette.text.secondary,
  },
  tagLink: {
    marginBottom: theme.spacing(1),
  },
  tagReference: {
    display: 'flex',
    alignItems: 'center',
    color: isDark(theme) ? theme.colors.white : theme.palette.secondary.main,
  },
  headerChildName: {
    margin: 0,
    marginRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    overflowX: 'auto',
  },
  checklistHeader: {
    top: 48,
    zIndex: 2,
    paddingLeft: theme.spacing(2),
    backgroundColor: '#f5f5f5',
    color: theme.palette.text.primary,
    boxShadow: (p) => (p.printView ? 'none' : '0px 5px 5px -3px grey'),
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
  },
  headerBtn: {
    color: 'red',
  },
  headerCriteria: {
    lineHeight: 0,
    position: 'absolute',
    fontSize: '10px',
    bottom: theme.spacing(1),
    color: theme.palette.action.disabled,
    fontWeight: 'normal',
  },
}));
